import { render } from "./OrderJobAssigneesTableComponent.vue?vue&type=template&id=73072740&ts=true"
import script from "./OrderJobAssigneesTableComponent.vue?vue&type=script&lang=ts"
export * from "./OrderJobAssigneesTableComponent.vue?vue&type=script&lang=ts"

import "./OrderJobAssigneesTableComponent.vue?vue&type=style&index=0&id=73072740&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__